import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import { Row, Col, CustomInput } from 'reactstrap';
import { IPipeInputsProps, UGOPipeInputsVM } from './UGOPipeInputsVM';
import { InputsElement } from '../../common/InputsElement';
import stores from 'cd-eft/models/Stores';

const { ugoDesignStore } = stores.AppStore;

export const PipeInputs = observer((props: IPipeInputsProps) => {
  const vmRef = useRef<UGOPipeInputsVM | null>(null);
  if (!vmRef.current) {
    vmRef.current = new UGOPipeInputsVM(props);
  }
  const vm = vmRef.current;
  const { PipelineDefaultSection } = vm.ugoInputsConfig;

  return (
    <>
      <Row>
        <Col>
          <InputsElement
            key="pipeline-default-input-material"
            config={PipelineDefaultSection.material}
            value={ugoDesignStore.inputForms.PipelineDefaultSection.material}
            onChange={(e) => vm.handleInputsOnChange(e, 'PipelineDefaultSection')}
            onBlur={(e) => vm.handleInputsOnBlur(e, 'PipelineDefaultSection')}
            red={vm.redHighlighting.PipelineDefaultSection.material}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <InputsElement
            config={PipelineDefaultSection.pressurizable}
            value={ugoDesignStore.inputForms.PipelineDefaultSection.pressurizable}
            onChange={(e) => vm.handleInputsOnChange(e, 'PipelineDefaultSection')}
            red={vm.redHighlighting.PipelineDefaultSection.pressurizable}
          />
        </Col>
        <Col>
          <div className="pipeline-default-toggle-group">
            <label
              htmlFor="pressureFlowToggle"
              className={
                vm.canSetPressureFlow
                  ? ugoDesignStore.inputForms.PipelineDefaultSection.pressureFlow
                    ? 'toggle-label text-primary font-weight-bold'
                    : 'toggle-label text-dark'
                  : 'toggle-label text-muted'
              }
            >
              {vm.canSetPressureFlow && ugoDesignStore.inputForms.PipelineDefaultSection.pressureFlow
                ? 'Pressure Flow On'
                : 'Pressure Flow Off'}
            </label>
            <CustomInput
              id="pressureFlowToggle"
              name="pressureFlowToggle"
              type="switch"
              bsSize="lg"
              disabled={!vm.canSetPressureFlow}
              checked={ugoDesignStore.inputForms.PipelineDefaultSection.pressureFlow}
              onChange={vm.togglePressureFlow}
              className={
                'checkbox-input-switch' +
                (ugoDesignStore.inputForms.PipelineDefaultSection.pressureFlow && vm.canSetPressureFlow
                  ? ' selected'
                  : '')
              }
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <InputsElement
            key="pipeline-default-input-pipeSize"
            config={PipelineDefaultSection.pipeSize}
            value={ugoDesignStore.inputForms.PipelineDefaultSection.pipeSize}
            onChange={(e) => vm.handleInputsOnChange(e, 'PipelineDefaultSection')}
            onBlur={(e) => vm.handleInputsOnBlur(e, 'PipelineDefaultSection')}
            red={vm.redHighlighting.PipelineDefaultSection.pipeSize}
          />
        </Col>
      </Row>
    </>
  );
});
